import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Nirno wordmark: capital N + dotless Turkish ı + lowercase rno, with red dot over ı.
export default function Logo({ to, inverse = false, size = 28 }) {
  const { user } = useAuth();
  const color = inverse ? "#fff" : "var(--ink)";
  // Route logged-in users to /explore when clicking the logo; anon → landing.
  const resolvedTo = to !== undefined ? to : (user ? "/explore" : "/");
  return (
    <Link
      to={resolvedTo}
      className="nav-logo"
      data-testid="nirno-logo"
      style={{ color, fontSize: size }}
    >
      <span>N</span>
      <span className="logo-i">
        ı
        <span className="logo-dot" />
      </span>
      <span>rno</span>
    </Link>
  );
}
